import { render } from "./MultiSelectField.vue?vue&type=template&id=dca01f16&scoped=true"
import script from "./MultiSelectField.vue?vue&type=script&lang=js"
export * from "./MultiSelectField.vue?vue&type=script&lang=js"

import "./MultiSelectField.vue?vue&type=style&index=0&id=dca01f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca01f16"]])

export default __exports__